<template>
    <div class="skill_category">
        <div class="skill_category_div">
            <div style="margin-top: 10px;padding-bottom:15px;font-size: large"> {{page_title}}</div>
            <div class="skill_category_diretion skill_selection">
                <div class="skill_category_title"> 大类：</div>
                <div class="skill_selection_card">
                    <a class="selection_button_a"
                       href="javascript:;"
                       v-for="category in skill_category"
                       :key="category['name']"
                       :class="current_category['name']===category['name'] ? 'selected' : ''"
                       @click="change_current_category(category)"
                    >
                        {{ category['name'] }}
                    </a>
                </div>
            </div>
        </div>
        <v-loader :source="current_category">
            <div class="libary_main_libray_content_cards">
                <div
                    class="libray_main_library_content_card"
                    v-for="(skill_info, index) in current_category.skills"
                    :key="index"
                >
                    <SkillCard :data="skill_info"
                    >
                    </SkillCard>
                </div>
            </div>
        </v-loader>
        <div class="self_score_foot">
            <button class="complete" @click="click_complete">完成自评</button>
        </div>
    </div>
    <!--<div class="skill_page_self_score_div">-->
        <!--<form @submit.prevent="submit($event)">-->
            <!--<table border="1">-->
                <!--<tr class='input_group'>-->
                    <!--<th class="skill_header">序号</th>-->
                    <!--<th class="skill_header">技能名称</th>-->
                    <!--<th class="skill_header">技能分类</th>-->
                    <!--<th class="skill_header">技能自评分</th>-->
                <!--</tr>-->
                <!--<tr class="skill_item" v-for="(skill, index) in skills" :key="index">-->
                    <!--<td>{{ index }}</td>-->
                    <!--<td>{{ skill.name }}</td>-->
                    <!--<td>{{ skill.class }}</td>-->
                    <!--<td>-->
                        <!--<input v-model='checked_data[index]' value='skilled' type='radio' v-bind:name='index'/>-->
                        <!--<label for="skilled">熟练</label>-->
                        <!--<input v-model='checked_data[index]' value='well' type='radio' v-bind:name='index'/>-->
                        <!--<label for="well">良好</label>-->
                        <!--<input v-model='checked_data[index]' value='ordinary' type='radio' v-bind:name='index'/>-->
                        <!--<label for="ordinary">一般</label>-->
                        <!--<input v-model='checked_data[index]' value='understood' type='radio' v-bind:name='index'/>-->
                        <!--<label for="understood">理解</label>-->
                        <!--<input v-model='checked_data[index]' value='incompetent' type='radio' v-bind:name='index'/>-->
                        <!--<label for="incompetent">不会</label>-->
                    <!--</td>-->
                <!--</tr>-->
            <!--</table>-->
            <!--<input type="submit" value="提交" class="submit" />-->
        <!--</form>-->


    <!--</div>-->
</template>
<script type="text/javascript">
import SkillCard from '@/components/common_components/cards/skill_card.vue'

import { mapState, mapActions  } from 'vuex'

export default {
    data() {
        return {
            page_title: null,
        }
    },
    components: {
        SkillCard
    },
    methods: {
        ...mapActions({
            change_current_category: 'skill/change_current_category',
            get_categories: 'skill/get_categories',
            get_categories_plan: 'skill_plan/get_categories',
            get_self_score: 'skill/get_self_score',
            check_user_skill: 'skill/check_user_skill',
            submit: 'skill/post_self_score',
            check_if_complete: 'skill/check_if_complete',
        }),
        click_complete(){
            let that = this
            this.check_if_complete().then(()=>{
                if (that.not_set_list.length === 0){
                    this.$router.push({name: 'skill_state'});
                }else{
                    let str = ''
                    that.not_set_list.forEach(da=>{
                        str += da.category + ' '
                    })
                    this.$confirm('未完成 ' + str +' 评估，是否继续评估?', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
                        this.change_current_category(this.temp_category)
                        this.$message({
                            type: 'info',
                            message: '继续完成评估'
                        })
                    }).catch(() => {
                        this.$router.push({name: 'skill_state'});
                    });
                }
            })

        },
    },
    computed: {
        ...mapState({
            skill_category: state => state.skill.skill_category,
            current_category: state => state.skill.current_category,
            skills: state => state.skill.skills,
            not_set_list: state => state.skill.not_set_list,
            temp_category: state => state.skill.temp_category,
        })
    },
    mounted: function () {
        this.get_categories()
        this.check_user_skill()
        let domain = localStorage.getItem('field')
        if (domain === "hr"){
            this.page_title = '专业技能评估'
        }else if(domain === "common"){
            this.page_title = '通用能力评估'
        }
    }
}

</script>
<style type="text/css">
.selection_button_a {
    display: inline-block;
    margin: 0 8px 0 0;
    padding: 4px 10px;
    font-size: 14px;
    color: #666;
    border-radius: 15px;
    cursor: pointer;
    transition: color 1s ease;
    transition: background .5s ease;
}

.selection_button_a:hover {
    color: #fff;
    background: #0099DD;
}

.selected {
    color: #fff;
    background: #66CCFF;
}

.skill_category_title {
    font-size: 16px;
    color: #666;
    width: 62px;
    min-width: 62px;
    margin-top: 2px;
}
.skill_category {
    width: 1170px;
    padding: 0 5px;
    margin-left: auto;
    margin-right: auto;
}

.skill_category_div {
    width: 100%;
    background: #fff;
    padding: 20px;
    border: 1px solid #eee;
    margin-bottom: 10px;
}

.skill_selection {
    display: flex;
    margin-bottom: 10px;
    /*flex-wrap: wrap;*/
}

.skill_category_tag {
    /*border-bottom: 2px solid #eee;*/
    /*margin-bottom: 0;*/
    /*padding-bottom: 10px;*/
}

.skill_selection_card {
    display: flex;
    flex-wrap: wrap;
}
.libary_main_libray_content_cards {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
}
.libary_main_libray_cards {
    display: flex;
    flex-wrap: wrap;
}

.libray_main_library_content_card {
    width: 33%;
    padding: 10px 15px;
}
.complete{
    padding: .375rem .5rem;
    color: #fff;
    background: #66CCFF;
    border: 1px solid #59C0F0;
    width: 100px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

</style>
